import { FunctionClient } from '@juvare/platform-sdk-js/FunctionClient';
export function getLogiUser() {
    return new FunctionClient()
        .executeFunction({
        functionName: 'getLogiUser',
    })
        .then((resp) => resp.result);
}
